import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  displayField,
  isNotEmpty,
  isEmptyVal,
  processMinute,
  getLabelFor,
} from "../../../utils/helpers";
import { paymentModeObjArr } from "../../../core/config/AppConstants";

const OrderAmountCell = ({
  rowData,
  positionFromRight = "30",
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const speaker = (
    <Popover title={t("ORDER") + " " + t("AMOUNT") + ":"}>
      <b>
        {t("ORDER")} {t("PRICE")}:
      </b>{" "}
      {displayField(rowData.order_price)}
      <p>
        {isNotEmpty(rowData.additional_cost) && (
          <p>
            {t("ADDITIONAL")} {t("COST")} :{t("+")}
            {displayField(rowData.additional_cost)}
          </p>
        )}
        {isNotEmpty(rowData.discount_percent) && (
          <p>
            {t("DISCOUNT")} {t("@")} :{t("-")}
            {displayField(rowData.discount_percent)}
            {t("%")}
          </p>
        )}
        {isNotEmpty(rowData.additional_discount) && (
          <p>
            {t("ADDITIONAL")} {t("DISCOUNT")} :{t("-")}
            {displayField(rowData.additional_discount)}
          </p>
        )}
        {isNotEmpty(rowData.order_tax) && (
          <p>
            {t("ORDER")} {t("TAX")} :{t("+")}
            {displayField(rowData.order_tax)}
          </p>
        )}
      </p>
      <p>
        <b>
          {t("FINAL")} {t("PAYABLE")}:
        </b>{" "}
        {displayField(rowData.order_final_payable)}
      </p>
      <p>
        <b>
          {t("PAYMENT")} {t("MODE")}:
        </b>{" "}
        {displayField(getLabelFor(rowData?.payment_mode, paymentModeObjArr))}
      </p>
      {isNotEmpty(rowData.remarks) && (
        <p>
          {t("REMARKS")} :{displayField(rowData.remarks)}
        </p>
      )}
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{displayField(rowData.order_price_after_discount)}</a>
      </Whisper>
    </Cell>
  );
};

export default OrderAmountCell;
